import { TransitionDataAttrs } from "../transition.js";
//#region src/core/ui/menu/data.ts
/** Root popup state used for positioning and surface transitions. */
const MenuPopupDataAttrs = {
	/** Present when the menu is open. */
	open: "data-open",
	/** Rendered positioning side after collision handling. Absent on submenus. */
	side: "data-side",
	/** Popover positioning alignment. Absent on submenus. */
	align: "data-align",
	...TransitionDataAttrs
};
/** State for one root or nested Content. */
const MenuContentDataAttrs = {
	/** Present while this Content is active or transitioning out. */
	open: "data-open",
	/** Present on Content when this menu is nested inside a parent menu. */
	isSubmenu: "data-submenu",
	/** Present when this Content has an open logical child. */
	childOpen: "data-child-open",
	...TransitionDataAttrs
};
/** All public Menu data attributes exposed to component transforms. */
const MenuDataAttrs = {
	...MenuPopupDataAttrs,
	...MenuContentDataAttrs
};
//#endregion
export { MenuContentDataAttrs, MenuDataAttrs, MenuPopupDataAttrs };

//# sourceMappingURL=data.js.map